import React, {
    useState,
    useEffect,
    useContext
}
from "react";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faBars
}
from "@fortawesome/free-solid-svg-icons";

import {
    store
}
from "../../../../context/store";

import {
    functions
}
from "../../../../constants/common-functions";

import omniscanLogo
from "../../../../../images/omniscanlogo.png";

import demoClientLogo
from "../../../../../images/democlient.png";

import MobileMenu
from "./MobileMenu";


//============================================================
// Mobile Header
//============================================================

export default function MobileHeader()
{

    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const client =
        globalState
            ?
            globalState.state.client
            :
            null;


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [clientLogo, setClientLogo] =
        useState("");

    const [menuOpen, setMenuOpen] =
        useState(false);


    //--------------------------------------------------------
    // Client logo
    //--------------------------------------------------------

    useEffect(
        function()
        {

            if(client)
            {

                const logoSource =
                    client.resourceFolderUrl +
                    "/client_logo.png";

                functions.getFileSource(
                    logoSource,
                    setClientLogo,
                    function()
                    {

                        setClientLogo(
                            demoClientLogo
                        );

                    }
                );

            }
            else
            {

                setClientLogo(
                    demoClientLogo
                );

            }

        },
        [client]
    );


    //========================================================
    // Events
    //========================================================

    const openMenu =
        function()
        {

            setMenuOpen(
                true
            );

        };


    const closeMenu =
        function()
        {

            setMenuOpen(
                false
            );

        };


    //========================================================
    // Styles
    //========================================================

    const header =
    {
        position:
            "sticky",

        top:
            "0px",

        zIndex:
            5000,

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "space-between",

        width:
            "100%",

        height:
            "64px",

        padding:
            "0 10px",

        boxSizing:
            "border-box",

        background:
            "rgba(255,255,255,0.88)",

        backdropFilter:
            "blur(20px)",

        WebkitBackdropFilter:
            "blur(20px)",

        borderBottom:
            "1px solid rgba(255,255,255,0.60)",

        boxShadow:
            "0 4px 14px rgba(0,0,0,0.10)"
    };


    //--------------------------------------------------------
    // OmniScan logo
    //--------------------------------------------------------

    const omniscanContainer =
    {
        display:
            "flex",

        alignItems:
            "center",

        minWidth:
            0,

        flexGrow:
            1
    };


    const omniscanLogoStyle =
    {
        display:
            "block",

        width:
            "145px",

        maxWidth:
            "42vw",

        height:
            "42px",

        objectFit:
            "contain",

        objectPosition:
            "left center"
    };


    //--------------------------------------------------------
    // Right controls
    //--------------------------------------------------------

    const rightContainer =
    {
        display:
            "flex",

        alignItems:
            "center",

        gap:
            "9px",

        flexShrink:
            0
    };


    const clientLogoPanel =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        width:
            "64px",

        height:
            "42px",

        padding:
            "4px 7px",

        boxSizing:
            "border-box",

        background:
            "rgba(255,255,255,0.48)",

        backdropFilter:
            "blur(12px)",

        WebkitBackdropFilter:
            "blur(12px)",

        border:
            "1px solid rgba(255,255,255,0.55)",

        borderRadius:
            "10px"
    };


    const clientLogoStyle =
    {
        display:
            "block",

        maxWidth:
            "100%",

        maxHeight:
            "32px",

        width:
            "auto",

        height:
            "auto",

        objectFit:
            "contain"
    };


    //--------------------------------------------------------
    // Burger
    //--------------------------------------------------------

    const burgerButton =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        width:
            "42px",

        height:
            "42px",

        flexShrink:
            0,

        borderRadius:
            "50%",

        border:
            "1px solid rgba(255,255,255,0.35)",

        background:
            "linear-gradient(180deg, #1f2937 0%, #111827 100%)",

        boxShadow:
            `
                inset 0 1px 2px rgba(255,255,255,0.35),
                inset 0 -2px 4px rgba(0,0,0,0.25),
                0 4px 10px rgba(0,0,0,0.22)
            `,

        color:
            "#ffffff",

        cursor:
            "pointer",

        fontSize:
            "17px"
    };


    //========================================================
    // Render
    //========================================================

    return (

        <>

            {/* ==============================================
                HEADER
            ============================================== */}

            <div style={header}>


                {/* OMNISCAN */}

                <div style={omniscanContainer}>

                    <img
                        src={omniscanLogo}
                        alt="OmniScan Pro"
                        style={omniscanLogoStyle}
                    />

                </div>


                {/* RIGHT SIDE */}

                <div style={rightContainer}>


                    {/* CLIENT */}

                    <div style={clientLogoPanel}>

                        <img
                            src={
                                clientLogo ||
                                demoClientLogo
                            }

                            alt="Client"

                            onError={
                                function(event)
                                {

                                    event.target.src =
                                        demoClientLogo;

                                }
                            }

                            style={clientLogoStyle}
                        />

                    </div>


                    {/* MENU */}

                    <div
                        style={burgerButton}
                        onClick={openMenu}
                    >

                        <FontAwesomeIcon
                            icon={faBars}
                        />

                    </div>


                </div>

            </div>


            {/* ==============================================
                MOBILE MENU
            ============================================== */}

			<MobileMenu
			    show={menuOpen}
			    close={closeMenu}
			/>

        </>

    );

}